/**
 * ！！！注意！！！
 * 目前发现ios微信6.5.16 6.5.17存在DB丢失的问题，导致写入的数据返回空。
 * 所以，这两个版本，请不要信任无返回值value的情况。
 */

/** 
 *  param = {
 *      key: 'xxx'
 *  }
 * 
 * ret = {
 *  err_msg: '',
 *  value: 'xxxx'
 * }
*/
import wxBridge from '../jsbridge/jsbridge_base.js';

wxBridge.getGameData = wxBridge.getGameData || function(param, callback) {
    wxBridge.invoke('getGameData', param, callback);
};

export default wxBridge;

export const {
 getGameData
} = wxBridge;
